// extracted by mini-css-extract-plugin
module.exports = {"list":"course_list_2GeMv","searchBar":"course_searchBar_qJLnj","item":"course_item_1YH8r","desc":"course_desc_1vK7j","name":"course_name_3j0Qk"};